import {
  fetchOpsInitStateCreator,
  fetchPendingReducersCreator,
  fetchRejectedReducersCreator,
  fetchResetReducersCreator,
} from '../../utils/helpers/fetchReducerHelpers';
import {
  getJobApplicationsConstants,
  updateJobApplicationConstants,
  cancelRejectionEmailConstants,
  createJobApplicationAdminConstants,
  deleteJobApplicationConstants,
  sendInterviewInviteConstants,
} from '../constants/jobApplicationsConstants';

import { JOB_APPLICATIONS_DOMAIN_NAME } from '../constants/constants';

/* eslint-disable no-param-reassign */
const { createSlice } = require('@reduxjs/toolkit');

const fetchOpNames = {
  pending: [
    'getJobApplications',
    'updateJobApplication',
    'cancelRejectionEmail',
    'createJobApplicationAdmin',
    'deleteJobApplication',
    'sendInterviewInvite',
  ],
  rejected: [
    'getJobApplications',
    'updateJobApplication',
    'cancelRejectionEmail',
    'createJobApplicationAdmin',
    'deleteJobApplication',
    'sendInterviewInvite',
  ],
  reset: [
    'getJobApplications',
    'updateJobApplication',
    'cancelRejectionEmail',
    'createJobApplicationAdmin',
    'deleteJobApplication',
    'sendInterviewInvite',
  ],
};

const fetchActionNames = {
  pending: [
    getJobApplicationsConstants,
    updateJobApplicationConstants,
    cancelRejectionEmailConstants,
    createJobApplicationAdminConstants,
    deleteJobApplicationConstants,
    sendInterviewInviteConstants,
  ],
  rejected: [
    getJobApplicationsConstants,
    updateJobApplicationConstants,
    cancelRejectionEmailConstants,
    createJobApplicationAdminConstants,
    deleteJobApplicationConstants,
    sendInterviewInviteConstants,
  ],
  reset: [
    getJobApplicationsConstants,
    updateJobApplicationConstants,
    cancelRejectionEmailConstants,
    createJobApplicationAdminConstants,
    deleteJobApplicationConstants,
    sendInterviewInviteConstants,
  ],
};

const fetchOps = fetchOpsInitStateCreator([
  'getJobApplications',
  'updateJobApplication',
  'cancelRejectionEmail',
  'createJobApplicationAdmin',
  'deleteJobApplication',
  'sendInterviewInvite',
]);

const fetchPendingReducers = fetchPendingReducersCreator(fetchActionNames.pending, fetchOpNames.pending, 'fetchOps');

const fetchRejectedReducers = fetchRejectedReducersCreator(fetchActionNames.rejected, fetchOpNames.rejected, 'fetchOps');

const fetchResetReducers = fetchResetReducersCreator(fetchActionNames.reset, fetchOpNames.reset, 'fetchOps');

const initialState = {
  posts: [],
  fetchOps,
  status: 'loading',
};

const jobApplicationsSlice = createSlice({
  name: JOB_APPLICATIONS_DOMAIN_NAME,
  initialState,
  extraReducers: {
    ...fetchPendingReducers,
    ...fetchRejectedReducers,
    ...fetchResetReducers,
    [getJobApplicationsConstants.fulfilled]: (state, { payload, meta }) => {
      state.fetchOps.getJobApplications.status = 'succeeded';
      state.fetchOps.getJobApplications.error = null;
      state.fetchOps.getJobApplications.meta.pointer = meta.pointer;
      state.posts = state.posts.concat(payload);
    },
    [getJobApplicationsConstants.reset]: (state) => {
      state.fetchOps.getJobApplications.status = 'idle';
      state.fetchOps.getJobApplications.error = null;
    },
    [updateJobApplicationConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.updateJobApplication.status = 'succeeded';
      state.fetchOps.updateJobApplication.error = null;
      const idx = state.posts.findIndex((p) => p.id === payload.id);
      if (idx !== -1) {
        state.posts[idx] = { ...state.posts[idx], ...payload };
      }
    },
    [cancelRejectionEmailConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.cancelRejectionEmail.status = 'succeeded';
      state.fetchOps.cancelRejectionEmail.error = null;
      const idx = state.posts.findIndex((p) => p.id === payload.id);
      if (idx !== -1) {
        state.posts[idx] = { ...state.posts[idx], ...payload };
      }
    },
    [createJobApplicationAdminConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.createJobApplicationAdmin.status = 'succeeded';
      state.fetchOps.createJobApplicationAdmin.error = null;
      state.posts.unshift(payload);
    },
    [deleteJobApplicationConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.deleteJobApplication.status = 'succeeded';
      state.fetchOps.deleteJobApplication.error = null;
      state.posts = state.posts.filter((p) => p.id !== payload.id);
    },
    [sendInterviewInviteConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.sendInterviewInvite.status = 'succeeded';
      state.fetchOps.sendInterviewInvite.error = null;
      const idx = state.posts.findIndex((p) => p.id === payload.id);
      if (idx !== -1) {
        state.posts[idx] = { ...state.posts[idx], ...payload };
      }
    },
  },
});

export const { postsLoaded, postUpdated, postDeleted } = jobApplicationsSlice.actions;

export default jobApplicationsSlice.reducer;
